module.exports = __webpack_public_path__ + "assets/img/josh.ee0203df.jpg";